/*eslint-disable*/
import React, { useState, useEffect, Fragment } from "react";
import {Link, useLocation} from "react-router-dom";

import APIClient from "../client";
import config from "../config.js"
import TableChart from "../components/Charts/TableChart.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";
import {useForm} from "react-hook-form";


const client = new APIClient(config);


export default function AdminFunderCapitalCreate() {

    const {
        register: registerCapital,
        formState: {errors: errors2},
        handleSubmit: handleSubmit2,
    } = useForm({
        mode: "onBlur",
    });

    const [funderId, setFunderId] = useState(null);
    const [funderViewId, setFunderViewId] = useState(null);
    const [funderName, setFunderName] = useState(null);


    const [data, setData] = useState(null);
    const [columnData, setColumnData] = useState(null);
    const [dropDowndata, setDropDown] = useState(null);
    const [funderData, setFunderData] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);

    const [capitalStatus, setCapitalStatus] = useState(null);
    const [capitalError, setCapitalError] = useState(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const {state} = useLocation();

    useEffect(() => {
        if (state != null) {
            setFunderId(state[0]["funder_view_id"]);
            setFunderName(state[0]["display_name"]);
            fetchFunderView(state[0]["funder_view_id"]);
            fetchDropdownData();
        }
        else {
            fetchFunders();
            fetchDropdownData();
        }

    }, []);

    const fetchDropdownData = () => {
    client.getFunderNames().then((data) => {
      setDropDown(data['data']['data']);
    });
  };

    const onSubmitCapital = (event) => {
        client.addFunderCapital(event).then(() => {
                setCapitalStatus("Funder Capital added.");
                setCapitalError(null);
                fetchFunders();
            })
            .catch((err) => {
                setCapitalError(err);
                setCapitalStatus(null);
            });
    };

    const fetchFunderView = (id) => {
        client.getFunderCapital(id).then((data) => {
            setLoading(false);
            setData(data['data']['data']);
            const columns = [
                {
                    key: "action",
                    text: "Action",
                    className: "action",
                    width: 100,
                    align: "left",
                    sortable: false,
                    cell: (record) => {
                        return (
                            <Fragment>
                                <button
                                    className="get-started text-blue rounded py-1 px-7 bg-yellow"
                                    onClick={() => {
                                        setOpenEdit(true);
                                        setFunderData(record);
                                    }}
                                >
                                    &nbsp;
                                    <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                    &nbsp; Add Capital View &nbsp;
                                </button>
                            </Fragment>
                        );
                    },
                },
                {
                    name: "Portfolio",
                    selector: (row) => row.funder_capital_view.display_name,
                },
                {
                    name: "funder_view_id",
                    selector: (row) => row.funder_view_id,
                },
                {
                    name: "avg_net_book",
                    selector: (row) => row.avg_net_book,
                },
                {
                    name: "total_fee",
                    selector: (row) => row.total_fee,
                },
                {
                    name: "start_date",
                    selector: (row) => row.start_date,
                },
                {
                    name: "id",
                    omit: true,
                    selector: (row) => row.id,
                },
            ];

            setColumnData(columns);

            setError(null);
        });
    };

    const fetchFunders = () => {
        client.getFunderCapitalViews().then((data) => {
            setLoading(false);
            setData(data['data']['data']);
            const columns = [
                {
                    key: "action",
                    text: "Action",
                    className: "action",
                    width: 100,
                    align: "left",
                    sortable: false,
                    cell: (record) => {
                        return (
                            <Fragment>
                                <button
                                    className="get-started text-blue rounded py-1 px-7 bg-yellow"
                                    onClick={() => {
                                        setOpenEdit(true);
                                        setFunderData(record);
                                    }}
                                >
                                    &nbsp;
                                    <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                    &nbsp; Add Capital View &nbsp;
                                </button>
                            </Fragment>
                        );
                    },
                },
                {
                    name: "Portfolio",
                    selector: (row) => row.funder_capital_view.display_name,
                },
                {
                    name: "funder_view_id",
                    selector: (row) => row.funder_view_id,
                },
                {
                    name: "avg_net_book",
                    selector: (row) => row.avg_net_book,
                },
                {
                    name: "total_fee",
                    selector: (row) => row.total_fee,
                },
                {
                    name: "start_date",
                    selector: (row) => row.start_date,
                },
                {
                    name: "id",
                    omit: true,
                    selector: (row) => row.id,
                },
            ];

            setColumnData(columns);

            setError(null);
        });
    };

    const ExpandedComponent = ({ data }) => <pre>{JSON.stringify(data, null, 2)}</pre>;
    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "Funder Capital Management";

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

                <section className="relative grad-1 pb-20">
                    <div className="container relative mx-auto pt-12 px-4 w-10/12">

                        {loading && (
                            <div className="text-xl font-medium">Loading...</div>
                        )}
                        {error && <CardError message={error}/>}

                        {data && (

                            <>


                            <h2 className="text-36 text-yellow mb-6">Manage Funder Capital View</h2>

                            <section className="relative pb-20">
                                <div className="container relative mx-auto pt-12 px-4">
                                    <div className="relative md:w-12/12 lg:w-12/12 px-4 mb-1">
                                        <div className="relative bg-white-7 w-full rounded-lg p-4 mb-8">
                                            <div className="w-full flex items-center">
                                                <div className="w-3/12">
                                                    <div className="relative flex flex-col text-white w-full">
                                                        {/*<FiatGroup className="size-btc-group"/>*/}
                                                        <i className="fa fa-user-circle fa-6" aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                                <div className="w-9/12">
                                                    <div className="relative flex flex-col w-full px-6">
                                                        <h2 className="text-24-performance text-white">Add Capital
                                                            View</h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr className="mb-4 bigHr"></hr>

                                            {dropDowndata ? (

                                                <form onSubmit={handleSubmit2(onSubmitCapital)}>

                                                    <div className="flex flex-wrap -mx-3 mb-6">

                                                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                                            <label
                                                                className="block uppercase tracking-wide text-white text-xs font-bold mb-2"
                                                                htmlFor="grid-first-name">
                                                                Funder
                                                            </label>
                                                            <select
                                                                className="relative m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 "
                                                                {...registerCapital("funder_view_id", {required: true})}
                                                            >
                                                                {dropDowndata.map((e) => <option value={e.id}
                                                                                                 key={e.id}>{e.display_name}</option>)}
                                                            </select>
                                                        </div>

                                                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                                            <label
                                                                className="block uppercase tracking-wide text-white text-xs font-bold mb-2"
                                                                htmlFor="avg_net_book">
                                                                avg_net_book
                                                            </label>
                                                            <input
                                                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                                id="avg_net_book" type="text"
                                                                placeholder="1000000" {...registerCapital("avg_net_book")} />
                                                        </div>
                                                        <div className="w-full md:w-1/2 px-3">
                                                            <label
                                                                className="block uppercase tracking-wide text-white text-xs font-bold mb-2"
                                                                htmlFor="total_fee">
                                                                total_fee
                                                            </label>
                                                            <input
                                                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                                id="total_fee" type="text"
                                                                placeholder="0.02" {...registerCapital("total_fee")}/>
                                                        </div>
                                                        <div className="w-full md:w-1/2 px-3">
                                                            <label
                                                                className="block uppercase tracking-wide text-white text-xs font-bold mb-2"
                                                                htmlFor="start_date">
                                                                start_date
                                                            </label>
                                                            <input
                                                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                                id="start_date" type="text"
                                                                placeholder="2024-12-01" {...registerCapital("start_date")}/>
                                                        </div>
                                                        <div className="w-full md:w-1/2 px-3">
                                                            <button
                                                                className="bg-yellow text-16-19 text-blue-v-dark py-2 px-12 rounded"
                                                                type="submit"
                                                            >
                                                                <i className="fa fa-rocket"
                                                                   aria-hidden="true"></i>

                                                                &nbsp; Add Capital &nbsp;
                                                            </button>
                                                            {capitalStatus !== null && (
                                                                <p className="text-yellow text-sm text-center italic">Funder
                                                                    Capital Added.</p>
                                                            )}

                                                            {capitalError !== null && (
                                                                <p className="text-red-500 text-center text-sm">Error
                                                                    adding Funder Capital.</p>
                                                            )}
                                                        </div>
                                                    </div>


                                                </form>

                                            ) : (<></>)
                                            }

                                        </div>

                                    </div>

                                </div>
                            </section>

                                <TableChart
                                    columns={columnData}
                                    data={data}
                                    defaultSortFieldId={1}
                                    dense
                                />

                            </>


                        )}

                    </div>

                </section>

        </>
    );
}

